export default "__VITE_ASSET__CWnsk6i0__"